import { render } from "./TableAction.vue?vue&type=template&id=544d9c0e&scoped=true"
import script from "./TableAction.vue?vue&type=script&lang=js"
export * from "./TableAction.vue?vue&type=script&lang=js"

import "./TableAction.vue?vue&type=style&index=0&id=544d9c0e&lang=scss&scoped=true"
import "./TableAction.vue?vue&type=style&index=1&id=544d9c0e&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544d9c0e"]])

export default __exports__